import { atom } from "recoil"

export const draftIdState = atom<string | undefined>({
  key: "atoms/contact/create/draftIdState",
  default: undefined,
})
